import React, { Component } from "react";
import { connect } from "react-redux";
import { usrRole } from "../../utils/dataUtil";
import { req_page_gqm_employmentAnalysisList } from "../../api";
import { Card, Table, Progress, Select, Tag } from "antd";
import { getGraduateAcademicYear } from "../../utils/dateUtil";
import "./alumni-employmentrate-statistics-list.css";

class AlumniEmploymentStatistics extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    yearGrade: getGraduateAcademicYear(new Date()) - 1,
    educationalSystem: "四技",
    division: "日間部",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items();
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { yearGrade, division, educationalSystem } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_gqm_employmentAnalysisList(
      userLevel,
      userCode,
      yearGrade,
      educationalSystem,
      division,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items, loading: false });

      //console.log(items);
    } else {
      const items = [];

      this.setState({ items, loading: false });
    }
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "系科別",
        width: "10%",
        align: "center",
        render: (item) => {
          const { ShortCollegeName, ShortDeptName } = item;
          return (
            <Tag
              color={this.style_switch_color_text(ShortCollegeName)}
              style={{ fontSize: "1.3em" }}
            >
              {ShortDeptName}
            </Tag>
          );
        },
      },
      {
        title: "就業/校友數",
        width: "10%",
        render: (item) => {
          const { ShortCollegeName, EmploymentAlumni, TotalAlumni } = item;
          return (
            <Tag
              color={this.style_switch_color_text(ShortCollegeName)}
              style={{ fontSize: "1.4em" }}
            >
              {EmploymentAlumni} / {TotalAlumni}
            </Tag>
          );
        },
      },
      {
        title: "就業比例",
        width: "80%",
        render: (item) => {
          const { ShortCollegeName, PercentNum } = item;
          return (
            <>
              <Progress
                percent={parseInt(PercentNum)}
                strokeColor={this.style_switch_color_progress_rate(
                  ShortCollegeName
                )}
                strokeWidth={20}
                trailColor={"Silver"}
              />
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  style_switch_color_progress_rate(column) {
    var str_Color = "Block";
    switch (column) {
      case "生":
        str_Color = "#339933";
        break;
      case "管":
        str_Color = "#3366cc";
        break;
      case "設":
        str_Color = "#cc6633";
        break;
      case "藝":
        str_Color = "#990000";
        break;
      case "旅":
        str_Color = "#9933cc";
        break;
      default:
        break;
    }
    return str_Color;
  }

  style_switch_color_text(column) {
    var str_Color = "Block";
    switch (column) {
      case "生":
        str_Color = "green";
        break;
      case "管":
        str_Color = "geekblue";
        break;
      case "設":
        str_Color = "orange";
        break;
      case "藝":
        str_Color = "red";
        break;
      case "旅":
        str_Color = "purple";
        break;
      default:
        break;
    }
    return str_Color;
  }

  //////////////////////////////////////////////////////////
  render() {
    const { loading, items, yearGrade, educationalSystem, division } =
      this.state;

    const title = (
      <div>
        <span>學年度：</span>
        <Select
          value={yearGrade}
          style={{ width: "20%" }}
          onChange={(value) => {
            this.setState({ yearGrade: value }, () => {
              this.api_list_items();
            });
          }}
        >
          <Select.Option value="110">110</Select.Option>
          <Select.Option value="109">109</Select.Option>
          <Select.Option value="108">108</Select.Option>
          <Select.Option value="107">107</Select.Option>
          <Select.Option value="106">106</Select.Option>
          <Select.Option value="105">105</Select.Option>
          <Select.Option value="104">104</Select.Option>
          <Select.Option value="103">103</Select.Option>
          <Select.Option value="102">102</Select.Option>
          <Select.Option value="101">101</Select.Option>
          <Select.Option value="100">100</Select.Option>
        </Select>
        <Select
          value={educationalSystem}
          style={{ width: "30%" }}
          onChange={(value) => {
            this.setState({ educationalSystem: value }, () => {
              this.api_list_items();
            });
          }}
        >
          <Select.Option value="四技">四技</Select.Option>
          <Select.Option value="二技">二技</Select.Option>
          <Select.Option value="七技">七技</Select.Option>
          <Select.Option value="研究所">研究所</Select.Option>
          <Select.Option value="二專">二專</Select.Option>
          <Select.Option value="五專">五專</Select.Option>
        </Select>
        <Select
          value={division}
          style={{ width: "29%" }}
          onChange={(value) => {
            this.setState({ division: value }, () => {
              this.api_list_items();
            });
          }}
        >
          <Select.Option value="日間部">日間部</Select.Option>
          <Select.Option value="進修部">進修部</Select.Option>
        </Select>
      </div>
    );
    return (
      <Card>
        <div style={{ fontSize: ".5em", color: "gray", textAlign: "right" }}>
          註：最終正確數據統計仍由研發處公告為主，本系統僅提供參考
        </div>
        {title}
        <Table
          style={{ width: "99%" }}
          loading={loading}
          rowKey="id"
          dataSource={items}
          pagination={false}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniEmploymentStatistics);
